import React, { useEffect, useState } from 'react';
import TimeTaxSupportSystemClient from '../../system';
import MessageCourier from '../../lib/MessageCourier';
import { User } from '../../system/User';
import { useTranslation } from 'react-i18next';
import SystemConfiguration from '../../system/configuration/SystemConfiguration';
import PeriodDatesBlockedSystem from '../../system/period_dates_blocked/PeriodDatesBlockedSystem';
import { defaultCommandBarButtonStyles } from '../../styles/button-styles';
import ViewWrapperWithCommandBar from '../Layout/ViewWrapperWithCommandBar';
import { Stack, DefaultPalette, ICommandBarItemProps } from "@fluentui/react";
import CustomCalendar from './CustomCalendar';
import { ListWorkingDays } from './ListWorkingDays';
import { IComboBoxOption } from '@fluentui/react';
import { IEmpresappals } from '../../system/empresappals/EmpresappalsSystem';

interface IActivityList {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  user: User;
  changeBlockUI: (state: boolean) => void;
  config: SystemConfiguration;
  periodsBlocked: PeriodDatesBlockedSystem;
}

export const WorkingDaysHolidays: React.FC<IActivityList> = ({ system, ...props }) => {
  const { t, i18n } = useTranslation();
  const itemsMenu = React.useMemo(
    (): ICommandBarItemProps[] => [
      {
        key: "title",
        text: t("Dias laborables y feriados"),
        iconProps: {
          iconName: "CalendarSettingsMirrored",
          color: DefaultPalette.themeLighterAlt,
          className: "text-title-btn",
        },
        buttonStyles: defaultCommandBarButtonStyles,
        className: "text-title-btn",
      },
    ],
    []
  );
  const [selectedCompany, setSelectedCompany] = useState<IComboBoxOption>();
  const [selectedDate, setSelectedDate] = useState<string>();
  const [isRegister, setIsRegister] = useState<any>(undefined);
  const [empresappals, setEmpresappals] = useState<IEmpresappals[]>([]);

  useEffect(() => {
    const empresappalsSystem = system.getEmpresappalsSystem();
    props.changeBlockUI(true);
    empresappalsSystem.getEmpresappals().then(({ data }) => {
      setEmpresappals(data);
      if (data.length > 0) {
        const defaultCompany = data.find(e => e.empp_id === props.user.getColEmppId());
        if (defaultCompany) {
          setSelectedCompany({ key: defaultCompany.empp_id, text: defaultCompany.empp_nombre , data: defaultCompany });
        }
      }
    }).finally(() => {
      props.changeBlockUI(false);
    });
  }, [])

  const handleRegisterChange = (isRegistered: any) => {
    setIsRegister(isRegistered);
  };

  const handleCountryChange = (country) => {
    setSelectedCompany(country);
  };

  const handleDateChange = (date) => {
    const dateFormatYear = new Date(date);
    setSelectedDate(dateFormatYear.getFullYear().toString());
  }

  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={""}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="standard"
    >
      <div
        style={{
            width: "100%",
            boxSizing: "border-box" ,
            padding: "10px",
            backgroundColor: "#FAF9F8",
            borderTop: "1px solid #E0E0E0",
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            overflowX: 'auto',
        }}
      >
        <CustomCalendar
          system={system}
          selectedCompany={selectedCompany}
          onDateChange={handleDateChange}
          onCompanyChange={handleCountryChange}
          onRegisterChange={handleRegisterChange}
          empresappals={empresappals}
          courier={props.courier}
        />
        <ListWorkingDays
          date={selectedDate}
          selectedCompany={selectedCompany}
          system={system}
          onRegisterChange={handleRegisterChange}
          isRegister={isRegister}
        />
      </div>
    </ViewWrapperWithCommandBar>
  );
};
